// extracted by mini-css-extract-plugin
export var orderDetails = "_uc-2";
export var orderImage = "_uc-1";
export var orderMeta = "_uc-3";
export var orderSummary = "_uc-0";
export var rightArrow = "_uc-4";